import React, { useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'

// components
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component'
import DeleteObjectWithModal from '../../../blockGroups/deletion/DeleteObjectWithModal/DeleteObjectWithModal.blockgroup'

// collections
import EquipmentRequestInfo from './collections/EquipmentRequestInfo/EquipmentRequestInfo.collection'
import EquipmentRequestDetailEquipment from './collections/EquipmentRequestDetailEquipment/EquipmentRequestDetailEquipment.collection'
import EquipmentRequestDetailProcessing from './collections/EquipmentRequestDetailProcessing/EquipmentRequestDetailProcessing.collection'
import EquipmentRequestDetailNotes from './collections/EquipmentRequestDetailNotes/EquipmentRequestDetailNotes.collection'

// wrapper
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// query
import { GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS, GET_EQUIPMENT_REQUEST_BY_ID_WITH_STATUS } from '../../../graphql/equipmentRequest/equipmentRequest.queries'
import { DELETE_EQUIPMENT_REQUEST } from '../../../graphql/equipmentRequest/equipmentRequest.mutations'

// mui
import { Typography, Grid, Container, Button, ButtonGroup, Stack } from '@mui/material'

// utils
import { createUserGroupList } from '../../../shared/privileges/userGroups'

// forms
import ProcessEquipmentRequestFormController from './ProcessEquipmentRequest.form.controller'
import EquipmentRequestDetailAddItemsFormController from './collections/EquipmentRequestDetailAddItems/EquipmentRequestDetailAddItems.form.controller'

export default function EquipmentRequestDetail({ usersGroups }) {
    const groups = createUserGroupList(usersGroups)
    const history = useHistory()
    const {requestId} = useParams()
    const [showProcess, setShowProcess] = useState(false)
    const [showAddItems, setShowAddItems] = useState(false)
    
    // Convert requestId to integer once
    const requestIdInt = parseInt(requestId)

    const handlePDFClick = () => {
        history.push(`/inventory/equipment-request/${requestId}/generate-pdf`)
    }

    return(<div id="EquipmentRequestDetail">
        {
            showProcess && <ProcessEquipmentRequestFormController visible={showProcess} closeForm={() => setShowProcess(false)} requestId={requestIdInt} />
        }

        {
            showAddItems && <EquipmentRequestDetailAddItemsFormController visible={showAddItems} closeForm={() => setShowAddItems(false)} requestId={requestIdInt} />
        }

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="space-between" alignItems={'center'}>
                <Grid item xs={6}><Typography variant="h2">Equipment Request</Typography></Grid>
                <Grid item xs={6} textAlign={'right'}>
                    <Stack direction='row' spacing={2} justifyContent={'flex-end'}>
                        <ActionButton label="Generate PDF" color="secondary" onClick={handlePDFClick} />

                        {
                            (groups.includes("Admin") || groups.includes("EquipmentRequestProcessing")) &&

                            <WithGqlQuery 
                                component={EquipmentRequestDetailProcessing}
                                query={GET_EQUIPMENT_REQUEST_BY_ID_WITH_STATUS}
                                variables={{ id: requestIdInt }}
                                onProcessClicked={() => setShowProcess(true)}
                                onAddItemsClicked={() => setShowAddItems(true)}
                            />

                        }
                    </Stack>
                 </Grid>
            </Grid>
        </Container>
        
        

        <Container maxWidth disableGutters>
            <Grid container spacing={2} justifyContent='space-between' alignItems={'stretch'}>
                <Grid item xs={4}><EquipmentRequestInfo id={requestIdInt} /></Grid>
                <Grid item xs={4}><EquipmentRequestDetailNotes id={requestIdInt} /></Grid>
            </Grid>
        </Container>
        

        <WithGqlQuery 
            component={EquipmentRequestDetailEquipment}
            query={GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS}
            variables={{ id: requestIdInt }}
        />

        {/* Delete Equipment Request for Admins */}
        {
            groups.includes("Admin") &&
            <DeleteObjectWithModal 
                id={requestIdInt}
                mutation={DELETE_EQUIPMENT_REQUEST}
                deleteLabel={"Delete Equipment Request"}
                deleteTitle={"Delete Equipment Request"}
                deleteMessage={"Are you sure you want to delete this Equipment Request?"}
                successObjectKey="deleteEquipmentRequest"
                entityName="Equipment Request"
            />
        }

    </div>)
}
